import { EditTabs } from "./EditTabs"
import { TypeSelection } from "./TypeSelection"

export const DocumentTypesEdit = EditTabs
export const DocumentTypesSelection = TypeSelection


// WEBPACK FOOTER //
// ./src/inventory/sections/documentTypes/index.ts